export enum ENodeContentInteractions {
  intendedToCreateContentForANode = 'intended_to_create_content_for_a_node',
  intendedToUpdateContentOfANode = 'intended_to_update_content_of_a_node',
  intendedToDeleteContentOfANode = 'intended_to_delete_content_of_a_node',
  // restore
}
